/* global Stripe */
import $ from 'jquery';

// Stripe.js comes from the js.stripe.com script on the pages that take payments; the class only
// touches it when constructed there.
export default class StripeForm {
  constructor(stripeConnectId = '') {
    if (stripeConnectId.length > 0) {
      this.stripe = new Stripe($('#stripe_public_key').val(), {
        stripeAccount: stripeConnectId,
      });
    } else {
      this.stripe = new Stripe($('#stripe_public_key').val());
    }

    this.initializeElements();
    this.hookUpErrorMessages();
  }

  initializeElements() {
    // load appropriate font
    const elementsGenerator = this.stripe.elements({
      fonts: [{ cssSrc: 'https://fonts.googleapis.com/css?family=Source+Sans+Pro' }],
    });

    // set common styles for all Stripe controls
    const style = {
      base: {
        color: '#555',
        fontWeight: 400,
        fontFamily: 'Source Sans Pro, Open Sans, Segoe UI, sans-serif',
        fontSize: '17px',
        fontSmoothing: 'antialiased',
        ':focus': { color: '#555' },
        '::placeholder': { color: '#ccc' },
        ':focus::placeholder': { color: '#ccc' },
      },
      invalid: {
        color: '#f74545',
        ':focus': { color: '#fa5a5a' },
        '::placeholder': { color: '#ccc' },
      },
    };
    const classes = { focus: 'focus', empty: 'empty', invalid: 'invalid' };

    // create Stripe elements and mount them
    const cardNumber = elementsGenerator.create('cardNumber', { style, classes });
    cardNumber.mount('#stripe-card-number');

    const cardExpiry = elementsGenerator.create('cardExpiry', { style, classes });
    cardExpiry.mount('#stripe-card-expiry');

    const cardCvc = elementsGenerator.create('cardCvc', { style, classes });
    cardCvc.mount('#stripe-card-cvc');

    this.elements = [cardNumber, cardExpiry, cardCvc];
  }

  hookUpErrorMessages() {
    const errorMessage = document.querySelector('.form-error--stripe');

    // Listen for errors from each Element, and show error messages in the UI.
    const savedErrors = {};
    this.elements.forEach(function (element, idx) {
      element.on('change', function (event) {
        if (event.error) {
          $(errorMessage).show();
          savedErrors[idx] = event.error.message;
          errorMessage.innerText = event.error.message;
        } else {
          savedErrors[idx] = null;

          // Loop over the saved errors and find the first one, if any.
          const nextError = Object.keys(savedErrors)
            .sort()
            .reduce(function (maybeFoundError, key) {
              return maybeFoundError || savedErrors[key];
            }, null);

          if (nextError) {
            // Now that they've fixed the current error, show another one.
            errorMessage.innerText = nextError;
          } else {
            // The user fixed the last error; no more errors.
            $(errorMessage).hide();
          }
        }
      });
    });
  }

  submit(callback) {
    // Use Stripe.js to create a token. We only need to pass in one Element
    // from the Element group in order to create a token. We can also pass
    // in the additional customer data we collected in our form.
    return this.stripe.createToken(this.elements[0]);
  }

  submitWithPaymentIntent(clientSecret) {
    console.log(clientSecret);
    return this.stripe.confirmCardPayment(clientSecret, {
      payment_method: { card: this.elements[0] },
    });
  }
}
